import styled from "styled-components";

export const HeaderDetailsDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    height: 100%;
    margin-right: auto;  
    font-size: 1.4rem;
    margin-left: 10px;
`;